import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import CoachAvatar from './CoachAvatar';
import { COPY } from './copy';

function RateButton({ label, active, onClick, children }) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={active}
      title={label}
      onClick={onClick}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-sm border-0 cursor-pointer ${active ? 'bg-muted text-foreground' : 'bg-transparent text-muted-foreground'}`}
    >
      {children}
    </button>
  );
}

// One coach message. Coach text is Markdown (short paragraphs, bold for the
// figure that matters, short lists); links open in a new tab. With onRate,
// a thumbs up/down pair sits next to the timestamp; clicking the active one
// clears it. reply marks the newest reply, which the conversation scrolls
// to.
export default function CoachMessage({ coachName, content, time, rating, onRate, reply = false, children }) {
  const rate = (value) => onRate(rating === value ? 'none' : value);

  return (
    <div className="flex items-start gap-3.5" data-testid="coach-message" data-reply={reply || undefined}>
      <div className="mt-px">
        <CoachAvatar name={coachName} />
      </div>
      <div className="flex-1 min-w-0 flex flex-col gap-2.5">
        <div className="george-prose text-[15px] leading-[1.6] text-foreground tabular-nums">
          <ReactMarkdown
            components={{
              a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
        {(time || onRate) && (
          <div className="flex items-center gap-1">
            {time && (
              <span className="font-label text-[10px] text-muted-foreground/75">
                {coachName} · {time}
              </span>
            )}
            {onRate && (
              <span className="inline-flex items-center ml-1.5" data-testid="message-rating">
                <RateButton label={COPY.helpful} active={rating === 'up'} onClick={() => rate('up')}>
                  <ThumbsUp size={14} />
                </RateButton>
                <RateButton label={COPY.notHelpful} active={rating === 'down'} onClick={() => rate('down')}>
                  <ThumbsDown size={14} />
                </RateButton>
              </span>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
